import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";

import { Discount } from "./discount.component";

type Props = {
    children?: string;
    promotionCodes: Array<any>;
    isLoading: boolean;
    cartHasItems: boolean;
};

const DiscountContainer = (props: Props) => {
    const dispatch = useThunkDispatch();

    const removePromotionCode = (code: string) => {
        dispatch(CartModule.removePromotionCode(code));
    };

    const addPromotionCode = (code: string, bonusCard?: string) => {
        dispatch(CartModule.addPromotionCode(code, bonusCard));
    };

    return (
        <Discount
            {...props}
            removePromotionCode={removePromotionCode}
            addPromotionCode={addPromotionCode}
        />
    );
};

export { DiscountContainer };
